<template>
  <div class="orderDetails">
    <a-skeleton :loading="loading" active> </a-skeleton>
    <a-skeleton :loading="loading" active> </a-skeleton>
    <a-skeleton :loading="loading" active> </a-skeleton>
    <div class="loja">
      <router-link to="/"
        ><i class="fas fa-arrow-left"></i> Voltar para loja</router-link
      >
    </div>
    <section class="detailsOrder" v-for="(dados, index) in infos" :key="index">
      <div class="blocked" v-if="bloqueioLiberado == null">
        <p>
          <i class="fas fa-lock"></i> Pedido bloqueado.
          <a
            href="/panel/orders/blockedDocuments"
            target="_blank"
            rel="noopener"
            >Clique aqui</a
          >
          para desbloquear o pedido e liberar o pagamento
        </p>
      </div>
      <div class="orderheader">
        <div class="header">
          <div class="header__order">
            <p><router-link to="/panel/orders">Vendas</router-link></p>
            <p>></p>
            <h1>{{ dados.NRPedido }}</h1>
            <h1 v-if="vendaZEFU">&nbsp;- Venda Entrega Futura</h1>
          </div>
          <div class="header__buttons">
            <button
              class="header__buttons--log"
              @click="exibirLog = !exibirLog"
            >
              <i class="fas fa-history"></i> Log de Alterações
            </button>
            <div class="header__logModal" v-if="exibirLog">
              <h3>Log de Alterações</h3>
              <div
                class="header__modalMessages"
                v-for="(infs, ind) in logStatus"
                :key="ind"
              >
                <p>
                  Usuário <span>{{ infs.UsuarioAlteracao }}</span> às
                  {{ moment(infs.dtAlteracao).format("DD/MM/YYYY HH:mm:ss") }}
                  de <span>{{ infs.OldStatus }}</span> para
                  <span>{{ infs.NewStatus }}</span>
                </p>
              </div>
            </div>
            <button @click="printOrder" class="header__buttons--print">
              <i class="fas fa-print"></i> Imprimir Pedido
            </button>
            <button
              @click="openModal = !openModal"
              class="header__buttons--cancel"
              v-if="
                dados.StatusPedido == 'AGUARDANDO PAGAMENTO' ||
                  dados.StatusPedido == 'PENDENTE'
              "
            >
              <i class="fas fa-times"></i> Cancelar Pedido
            </button>

            <div class="header__modalCancelOrder" v-if="openModal">
              <div class="header__modalTitle">
                <h3 style="color: black">
                  Deseja cancelar o pedido {{ dados.NRPedido }}?
                </h3>
                <i class="fas fa-times" @click="openModal = false"></i>
              </div>
              <!-- <div class="header__modalBody">
                <label for="">Confirme sua senha:</label>
                <input type="password" v-model="userPassword" />
              </div> -->
              <div class="header__modalFooter">
                <button
                  class="header__modalFooter--cancel"
                  @click="cancelOrder()"
                >
                  Cancelar Pedido
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            style="display: flex; justify-content: right; margin: 10px"
            v-if="dados.OvSAP"
          >
            <p
              style="
                border: 1px solid #1a99d8;
                border-radius: 10px;
                padding: 7px;
              "
            >
              OV SAP:{{ dados.OvSAP }}
            </p>
          </div>
        </div>
      </div>

      <div class="cards">
        <div class="cards__item cards__item--client">
          <i
            class="fas fa-level-down-alt icon-change"
            @click="parceiro = !parceiro"
          ></i>

          <div class="client" v-if="!parceiro">
            <h3>Cliente</h3>
            <h4>{{ dados.dadosCliente.nmcliente_razao }}</h4>
            <p>
              <i class="fas fa-envelope"></i>
              <a :href="'mailto:' + dados.dadosCliente.email">{{
                dados.dadosCliente.email
              }}</a>
            </p>
            <p>
              <i class="fas fa-phone-square-alt"></i>
              <a
                :href="
                  'tel:' + dados.telefone[0].DDD + dados.telefone[0].NRTelefone
                "
                >({{ dados.telefone[0].DDD }})
                {{ dados.telefone[0].NRTelefone }}</a
              >
            </p>
            <p>
              <i class="fas fa-id-card"></i> {{ dados.dadosCliente.cpfcnpj }}
            </p>
            <p>
              <i class="fas fa-sticky-note"></i> Observação NF:
              <strong>{{ dados.observacao }}</strong>
            </p>
          </div>

          <div class="channel" v-if="parceiro">
            <h3>Canal de Vendas</h3>
            <h4>{{ dados.affiliateId }}</h4>
            <p>
              <i class="fas fa-user"></i> Vendedor:
              <strong>{{ dados.NmVendedor }}</strong>
            </p>
            <p>
              <i class="fas fa-sort-numeric-up-alt"></i> Código do vendedor:
              <strong>{{ dados.vendedor }}</strong>
            </p>
            <p>
              <i class="fas fa-users"></i> Parceiro:
              <strong>{{ dados.NMParceiro }}</strong>
            </p>
            <p>
              <i class="fas fa-sort-numeric-down-alt"></i> Código do parceiro:
              <strong>{{ dados.parceiro }}</strong>
            </p>
            <p>
              <i class="fas fa-percent"></i> Percentual de RT:
              <strong v-if="valorTotalRTSolar > 0"
                >{{
                  (
                    (parseFloat(valorTotalRTSolar) / dados.vlliquido) *
                    100
                  ).toFixed(2)
                }}%</strong
              >
              <strong v-else>{{ dados.ZPRT }}</strong>
            </p>
            <p>
              <i class="fas fa-money-bill-alt"></i> Valor do RT:
              <strong v-if="valorTotalRTSolar > 0">
                {{ valorTotalRTSolar | toCurrency }}
              </strong>
              <strong v-else>{{
                ((dados.vlliquido / 100) * dados.ZPRT) | toCurrency
              }}</strong>
            </p>
          </div>
        </div>

        <div class="cards__item cards__item--address">
          <h3>Endereço de Entrega</h3>
          <h4>
            {{ dados.dadosCliente.enderecoentrega.cidade }} -
            {{ dados.dadosCliente.enderecoentrega.uf }}
          </h4>
          <p>
            {{ dados.dadosCliente.enderecoentrega.logradouro }},
            {{ dados.dadosCliente.enderecoentrega.nrresidencia }}
          </p>
          <p>{{ dados.dadosCliente.enderecoentrega.bairro }}</p>
          <p>
            {{ dados.dadosCliente.enderecoentrega.cidade }} -
            {{ dados.dadosCliente.enderecoentrega.uf }}
          </p>
          <p>{{ dados.dadosCliente.enderecoentrega.cep }}</p>
          <p>
            <i class="fas fa-truck"></i> Entrega até:
            <span v-if="dados.PrevisaoEntrega != null">{{
              moment(dados.PrevisaoEntrega).format("DD/MM/YYYY")
            }}</span>
            <span v-if="!dados.PrevisaoEntrega"
              >Aguardando aprovação do pagamento</span
            >
          </p>
        </div>
        <div class="cards__item cards__item--medium">
          <h3>Valores</h3>
          <h4>{{ (dados.vlliquido + dados.vltotalfrete) | toCurrency }}</h4>
          <p>
            Preço: <span>{{ dados.vlBruto | toCurrency }}</span>
          </p>
          <p>
            Descontos: <span>{{ dados.vlDesconto | toCurrency }}</span>
          </p>
          <p>
            Preço com desconto: <span>{{ dados.vlliquido | toCurrency }}</span>
          </p>
          <p>
            Valor do Frete: <span>{{ dados.vltotalfrete | toCurrency }}</span>
          </p>
          <p>
            Preço Final com Frete:
            <span>{{
              (dados.vlliquido + dados.vltotalfrete) | toCurrency
            }}</span>
          </p>
          <p>
            Valor do RT:
            <strong v-if="valorTotalRTSolar > 0">
              {{ valorTotalRTSolar | toCurrency }}
            </strong>
            <strong v-else>{{
              ((dados.vlliquido / 100) * dados.ZPRT) | toCurrency
            }}</strong>
          </p>
        </div>
        <div class="cards__item cards__item--medium">
          <h3>Status</h3>
          <div
            class="cards__infoStatus"
            v-if="dados.StatusPedido == 'ENTREGUE'"
          >
            <p class="cards__infoStatus--entregue">
              {{ dados.StatusPedido }}
            </p>
          </div>

          <div
            v-if="dados.StatusPedido == 'PENDENTE'"
            class="cards__infoStatus"
          >
            <p class="cards__infoStatus--pendente">
              {{ dados.StatusPedido }}
            </p>
          </div>
          <div
            v-if="dados.StatusPedido == 'APROVADO'"
            class="cards__infoStatus"
          >
            <p class="cards__infoStatus--aprovado">
              {{ dados.StatusPedido }}
            </p>
          </div>
          <div
            v-if="dados.StatusPedido == 'CANCELADO'"
            class="cards__infoStatus"
          >
            <p class="cards__infoStatus--cancelado">
              {{ dados.StatusPedido }}
            </p>
          </div>
          <div
            v-if="dados.StatusPedido == 'AGUARDANDO PAGAMENTO'"
            class="cards__infoStatus"
          >
            <p class="cards__infoStatus--aguardandoPagamento">
              {{ dados.StatusPedido }}
            </p>
            <!-- <div class="cards__infoStatus">
              <router-link
                :to="'/payment?Order=' + window.btoa(dados.NRPedido)"
                target="_blank"
                v-if="frmPgmtIncompleta && bloqueioLiberado != null"
                class="cards__infoStatus--pay"
                >Pagar</router-link
              >
            </div> -->
          </div>
          <div
            v-if="dados.StatusPedido == 'ANALISE DE RISCO'"
            class="cards__infoStatus"
          >
            <p class="cards__infoStatus--analiseRisco">
              {{ dados.StatusPedido }}
            </p>
          </div>
          <div
            v-if="dados.StatusPedido == 'EXPIRADO'"
            class="cards__infoStatus"
          >
            <p class="cards__infoStatus--expirado">
              {{ dados.StatusPedido }}
            </p>
          </div>
          <div
            v-if="dados.StatusPedido == 'FATURADO'"
            class="cards__infoStatus"
          >
            <p class="cards__infoStatus--faturado">
              {{ dados.StatusPedido }}
            </p>
          </div>
          <div
            v-if="dados.StatusPedido == 'PARCIALMENTE FATURADO'"
            class="cards__infoStatus"
          >
            <p class="cards__infoStatus--parcialmenteFaturado">
              {{ dados.StatusPedido }}
            </p>
          </div>
        </div>
      </div>

      <div class="itemsPayment">
        <div class="itemsPayment__items">
          <h3>Itens do Pedido</h3>

          <div
            class="itemsPayment__product"
            v-for="(itens, i) in itensPedido"
            :key="i"
          >
            <div class="itemsPayment__image">
              <img
                @click="productDetails(itens.sku, itens.vlliquido)"
                :src="itens.linkimagem"
                :alt="itens.dsConjunto"
              />
            </div>
            <div class="itemsPayment__details">
              <p>
                {{ itens.dsConjunto }}
              </p>
              <p>
                <span>REFID:</span> {{ itens.RefID }} |
                <span>Código Interno:</span> {{ itens.sku }}
              </p>
              <p v-if="itens.Capacidade != 'NÃO INFORMADO'">
                <span>Capacidade:</span> {{ itens.Capacidade }}
              </p>
              <p><span>Marca:</span> {{ itens.Marca }}</p>
              <p><span>Categoria:</span> {{ itens.categoria }}</p>
              <p><span>Expedição:</span> {{ itens.Expedicao }}</p>
              <ul>
                <h4>Itens do Kit:</h4>
                <li v-for="(comps, ind) in itens.componentes" :key="ind">
                  {{ comps.RefID }} - {{ comps.Descricao }} -
                  {{ comps.vlComponente | toCurrency }}
                </li>
              </ul>
            </div>

            <div class="itemsPayment__valueQuantity">
              <p v-if="itens.qtd == 1">{{ itens.qtd }} item</p>
              <p v-else-if="itens.qtd > 1">{{ itens.qtd }} itens</p>
              <p>{{ itens.VlLiquido | toCurrency }}</p>
            </div>
          </div>

          <div v-if="dadosSolar">
            <div
              v-for="(itens, i) in dadosSolar"
              :key="i + '-dadosSolar'"
              style="
                background-color: #ffffff;
                padding: 20px;
                border: 1px solid #ccc;
                border-radius: 5px;
                margin-top: 5px;
              "
            >
              <div class="row">
                <div class="col-8">
                  <div class="itemsPayment__details">
                    <p>
                      {{ itens.dsproduto }}
                    </p>
                    <p>
                      <span>REFID:</span> {{ itens.RefID }} |
                      <span>Código Interno:</span> {{ itens.sku }}
                    </p>
                    <p><span>Expedição:</span> {{ itens.deposito }}</p>
                  </div>
                </div>
                <div class="col-4">
                  <div
                    class="itemsPayment__valueQuantity"
                    style="font-weight: bold"
                  >
                    <v-app>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <p v-bind="attrs" v-on="on">
                            {{ (itens.yven - itens.ydes) | toCurrency }}
                          </p>
                        </template>
                        <span>Desconto de {{ itens.ydes | toCurrency }}</span>
                      </v-tooltip>
                    </v-app>
                  </div>
                </div>
              </div>
              <div style="padding: 12px">
                <div class="row">
                  <h4>Itens do Kit:</h4>
                </div>
                <div class="row" style="margin-left: 10px">
                  <ul>
                    <div
                      v-for="(comps, ind) in itens.orderConfigsValue"
                      :key="ind"
                    >
                      <li v-if="comps.descicao">
                        {{ comps.descicao }}
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="itemsPayment__block">
          <!-- Exibe formas de pagamentos incompletas -->
          <div
            class="itemsPayment__card"
            v-if="dados.frmPagamentoIncompleta.length > 0"
          >
            <h3>Formas de Pagamento</h3>
            <div
              class="itemsPayment__itemCard"
              v-for="(pgmt, indexx) in dados.frmPagamentoIncompleta"
              :key="indexx"
            >
              <div class="itemsPayment__methodPayment">
                <div>
                  <h4>{{ pgmt.dsformapgto }}</h4>
                  <p class="itemsPayment__itemCard--boleto">
                    {{ pgmt.nrparcela }}x de {{ (pgmt.vlTotal /  pgmt.nrparcela) | toCurrency }} =
                    {{ pgmt.vlTotal | toCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Exibe formas de pagamento geradas / Completas -->
          <div class="itemsPayment__card" v-if="dados.frmPagamento.length > 0">
            <h3>Formas de Pagamento</h3>
            <div
              class="itemsPayment__itemCard"
              v-for="(pgmt, indexx) in dados.frmPagamento"
              :key="indexx"
            >
              <div
                class="itemsPayment__methodPayment"
                v-if="pgmt.cdFormapgto == 6 ||
										pgmt.cdFormapgto == 203"
              >
                <h4 >{{ (pgmt.dsformapgto).replace("GIFT CARD", "PROFITZ") }}</h4>
                <p class="itemsPayment__itemCard--boleto">
                  {{ pgmt.nrparcela }}x de {{ pgmt.vlTotal | toCurrency }} =
                  {{ pgmt.vlTotal | toCurrency }}
                </p>
                <a
                  v-if="dados.StatusPedido !== 'CANCELADO' && pgmt.cdFormapgto == 6"
                  :href="pgmt.urlBoleto"
                  target="_blank"
                  rel="noopener"
                  ><i class="fas fa-print"></i> Imprimir Boleto</a
                >
              </div>

              <div
                class="itemsPayment__methodPayment"
                v-if="pgmt.cdFormapgto == 16"
              >
                <h4>{{ pgmt.dsformapgto }}</h4>
                <p>
                  {{ pgmt.nrparcela }}x de
                  {{ (pgmt.vlTotal / pgmt.nrparcela) | toCurrency }}
                  = {{ pgmt.vlTotal | toCurrency }}
                </p>
                <p>
                  Usuário de Aprovação:
                  <span>{{ pgmt.usuarioaprovacao }}</span>
                </p>
              </div>

              <div
                class="itemsPayment__methodPayment"
                v-if="pgmt.cdFormapgto == 917"
              >
                <h4>{{ pgmt.dsformapgto }}</h4>
                <p>
                  {{ pgmt.nrparcela }}x de
                  {{ (pgmt.vlTotal / pgmt.nrparcela) | toCurrency }}
                  = {{ pgmt.vlTotal | toCurrency }}
                </p>

                <div v-if="pgmt.dtbaixa && pgmt.usuarioaprovacao">
                  <p>
                    Usuário de Aprovação:
                    <span>{{ pgmt.usuarioaprovacao }}</span>
                  </p>
                  <p>
                    Data de Liberação:
                    <span>{{
                      moment(pgmt.dtbaixa).format("DD/MM/YYYY HH:mm:ss")
                    }}</span>
                  </p>
                  <p>
                    Código de Autorização:
                    <span>{{ pgmt.cdautorizacao }}</span>
                  </p>
                  <p>
                    Cartão de Crédito:
                    <span
                      >{{ pgmt.firstDigits }}*****{{ pgmt.lastDigits }}</span
                    >
                  </p>
                  <p>
                    TID: <span>{{ pgmt.TID }}</span>
                  </p>
                  <p>
                    Método de Pagamento:
                    <span>{{ pgmt.PaymentMethod }}</span>
                  </p>
                </div>
                <div
                  v-else-if="
                    dados.StatusPedido !== 'CANCELADO' &&
                      dados.StatusPedido !== 'EXPIRADO' &&
                      pgmt.situacao === null
                  "
                  style="margin-top: 20px;"
                >
                  <router-link
                    :to="
                      `/payment?Order=${window.btoa(
                        dados.NRPedido
                      )}&Seq=${window.btoa(pgmt.id)}`
                    "
                    target="_blank"
                    class="cards__infoStatus--pay"
                  >
                    <i
                      class="fas fa-credit-card"
                      style="margin-right: 10px;"
                    ></i>
                    Link de pagamento
                  </router-link>
                </div>
                <div v-else-if="pgmt.situacao">
                  <p style="color: #e29d1e;">{{ pgmt.situacao }}</p>
                </div>
              </div>

              <div
                class="itemsPayment__methodPayment"
                v-if="
                  pgmt.cdFormapgto == 904 ||
                    pgmt.cdFormapgto == 905 ||
                    pgmt.cdFormapgto == 27 ||
                    pgmt.cdFormapgto == 28 ||
                    pgmt.cdFormapgto == 912
                "
              >
                <h4>{{ pgmt.dsformapgto }}</h4>
                <p>
                  {{ pgmt.nrparcela }}x de
                  {{ (pgmt.vlTotal / pgmt.nrparcela) | toCurrency }}
                  = {{ pgmt.vlTotal | toCurrency }}
                </p>
              </div>
              <div v-if="pgmt.cdFormapgto == 904">
                <div
                  class="itemsPayment__itemCard"
                  v-for="(boletosp, indexx) in dados.boletosParcelados"
                  :key="indexx"
                >
                  <a :href="boletosp" target="_blank">
                    <i class="fas fa-print"> Download boleto</i></a
                  >
                </div>
              </div>

              <div
                class="itemsPayment__methodPayment"
                v-if="pgmt.cdFormapgto == 900"
              >
                <h4>{{ pgmt.dsformapgto }}</h4>
                <p>
                  {{ pgmt.nrparcela }}x de {{ pgmt.vlTotal | toCurrency }} =
                  {{ pgmt.vlTotal | toCurrency }}
                </p>
              </div>

              <div
                class="itemsPayment__methodPayment"
                v-if="pgmt.cdFormapgto == 20"
              >
                <h4>{{ pgmt.dsformapgto }}</h4>
                <p>
                  {{ pgmt.nrparcela }}x de
                  {{ (pgmt.vlTotal / pgmt.nrparcela) | toCurrency }}
                  = {{ pgmt.vlTotal | toCurrency }}
                </p>
                <br />
                <div
                  v-if="
                    statusPedido != 'CANCELADO' && statusPedido != 'APROVADO'
                  "
                >
                  <img
                    :src="imagePix"
                    style="
                      width: 177px;
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                    "
                    @click="clickPix()"
                  />
                  <p style="text-align: center">
                    Clique sobre a imagem para copiar o código
                  </p>
                  <div style="padding: 20px">
                    <p>Código:</p>
                    <p id="to-copy" style="word-wrap: break-word">
                      {{ codPix }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="itemsPayment__blockade" v-if="bloqueios.length > 0">
            <div class="itemsPayment__card">
              <h3>Bloqueio</h3>
              <div
                class="itemsPayment__itemCard"
                v-for="(bloq, i) in bloqueios"
                :key="i"
              >
                <p>
                  Descrição do Bloqueio:
                  <span>{{ bloq.DS_BLOQUEIO }}</span>
                </p>
                <p>
                  Data do Bloqueio:
                  <span>{{
                    moment(bloq.DT_INCLUSAO).format("DD/MM/YYYY HH:mm:ss")
                  }}</span>
                </p>
                <p>
                  Alçada: <span>{{ bloq.Alcadas }}</span>
                </p>
                <p v-if="bloq.DT_LIBERACAO != null">
                  Liberado às
                  <span
                    >{{
                      moment(bloq.DT_LIBERACAO).format("DD/MM/YYYY HH:mm:ss")
                    }}
                    por {{ bloq.USUARIO_LIBERACAO }}</span
                  >
                </p>
              </div>
            </div>
          </div>

          <div class="itemsPayment__actions">
            <h3>Ações</h3>
            <button @click="addMensagemPedido = !addMensagemPedido">
              Adicionar mensagem ao pedido
            </button>
            <div class="itemsPayment__addMessage" v-if="addMensagemPedido">
              <textarea name="" id="" cols="37" rows="7"></textarea>
              <button>Enviar Mensagem</button>
            </div>
            <button @click="vincularPedido = !vincularPedido">
              Vincular pedido a outro
            </button>
            <div class="itemsPayment__linkOrder" v-if="vincularPedido">
              <div class="itemsPayment__linkGroup">
                <input type="checkbox" name="" id="" />
                <select name="" id="">
                  <option value="">Amazon</option>
                  <option value="">B2W</option>
                  <option value="">Cnova</option>
                  <option value="">Carrefour</option>
                  <option value="">Leveros Integra</option>
                  <option value="">Magazine Luiza</option>
                  <option value="">Mercado Livre</option>
                  <option value="">VTEX</option>
                </select>
                <input type="text" name="" id="" />
                <button>Vincular</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="timeline">
        <h2>DETALHES DO PEDIDO</h2>
        <a-timeline mode="alternate">
          <a-timeline-item>
            <a-icon
              slot="dot"
              type="inbox"
              style="
                font-size: 20px;
                color: #fff;
                background: #005a64;
                border-radius: 100%;
                padding: 5px;
              "
            />
            <p class="item__title">
              {{ moment(dados.dtPedido).format("DD/MM/YYYY HH:mm:ss") }}
            </p>
            <p>
              Pedido <span>{{ dados.NRPedido }}</span> criado com sucesso no
              Leveros Integra.
            </p>
            <p>
              A modalidade de entrega é
              <span>{{ dados.transportadora.split("-")[0] }}</span>
            </p></a-timeline-item
          >
          <a-timeline-item>
            <a-icon
              slot="dot"
              type="credit-card"
              style="
                font-size: 20px;
                color: #fff;
                background: #ffce00;
                border-radius: 100%;
                padding: 5px;
              "
            />
            <p class="item__title">
              {{ moment(dados.dtPedido).format("DD/MM/YYYY HH:mm:ss") }}
            </p>
            <p>Aguardando pagamento do pedido</p></a-timeline-item
          >
          <a-timeline-item v-for="inf in timeline" :key="inf.contteudo">
            <a-icon
              v-if="inf.conteudo != null"
              slot="dot"
              type="mail"
              style="
                font-size: 20px;
                color: #fff;
                background: #4cdddd;
                border-radius: 100%;
                padding: 5px;
              "
            />
            <a-icon
              v-else-if="inf.status === 'CANCELADO'"
              slot="dot"
              type="close"
              style="
                font-size: 20px;
                color: #fff;
                background: #ff0000b5;
                border-radius: 100%;
                padding: 5px;
              "
            />
            <a-icon
              v-else
              slot="dot"
              type="hourglass"
              style="
                font-size: 20px;
                color: #fff;
                background: #6fffaf;
                border-radius: 100%;
                padding: 5px;
              "
            />
            <p class="item__title">
              {{ moment(inf.dataOcorrencia).format("DD/MM/YYYY HH:mm:ss") }}
            </p>
            <p class="item__subtitle" v-if="inf.status === 'APROVADO'">
              Pagamento Aprovado!
            </p>
            <div class="item__billed" v-if="inf.status === 'FATURADO'">
              <p class="item__subtitle">Pedido Faturado!</p>
              <div
                class="item__infos"
                v-for="(nf, index) in dados.notafiscal"
                :key="index"
              >
                <p><strong>Número da NF:</strong> {{ nf.NRNota }}</p>
                <p>
                  <strong>Data:</strong>
                  {{ moment(nf.dtNF).format("DD/MM/YYYY") }}
                </p>
                <p><strong>Chave de Acesso:</strong> {{ nf.ChaveNF }}</p>
                <a
                  :href="
                    'https://www.leverosintegra.com.br/Danfe/NFe' +
                      nf.ChaveNF +
                      '.pdf'
                  "
                  target="_blank"
                  rel="noopener"
                >
                  <svg
                    class="svg-inline--fa fa-file-pdf fa-w-12"
                    width="25px"
                    aria-hidden="true"
                    data-prefix="fas"
                    data-icon="file-pdf"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="red"
                      d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
            <iframe
              v-if="inf.conteudo != null"
              :srcdoc="inf.conteudo"
              frameborder="0"
              width="100%"
              height="300px"
            ></iframe>
            <p v-else>{{ inf.status }}</p>
          </a-timeline-item>

          <a-timeline-item v-for="(ocorr, ind) in dados.Ocorrencias" :key="ind">
            <a-icon
              slot="dot"
              type="car"
              style="
                font-size: 20px;
                color: #fff;
                background: #002d32;
                border-radius: 100%;
                padding: 5px;
              "
            />
            <p class="item__title">
              {{ ocorr.dtOcorrencia }}
              {{ moment(ocorr.dtOcorrencia).format("DD/MM/YYYY HH:mm:ss") }}
            </p>
            <p>{{ ocorr.dsOcorrencia }}</p>
          </a-timeline-item>
        </a-timeline>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      addMensagemPedido: false,
      vincularPedido: false,
      token: null,
      infos: [],
      itensPedido: [],
      bloqueios: [],
      logStatus: [],
      exibirLog: false,
      loading: false,
      orderPrint: null,
      openModal: false,
      dadosSolar: null,
      bloqueioLiberado: [],
      timeline: [],
      frmPgmtIncompleta: false,
      parceiro: false,
      userPassword: null,
      nrPedido: null,
      window: window,
      imagePix: null,
      codPix: null,
      statusPedido: null,
      vendaZEFU: null,
      valorTotalRTSolar: null,
    };
  },
  methods: {
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        if (dados != undefined) {
          this.token = dados.token;
        } else {
          this.token = "";
        }

        var url = new URL(window.location.href);
        var order = url.searchParams.get("Pedido");
        this.nrPedido = order;

        try {
          this.loading = true;
          const response = await axios.get(
            `https://www.leverosintegra.com.br/MAP/api/pedido/${order}-token${this.token}`
            //`http://qa.leverosintegra.com.br/map/api/pedido/${order}-token${this.token}`
          );
          this.infos = response.data;
          this.loading = false;

          let itens = this.infos;
          let log = this.infos;
          let bloqueio = this.infos;
          let bloqueioLiberado = response.data;
          let line = response.data;

          let frmPgmt = response.data;

          frmPgmt.filter((item) => {
            let arr = item.frmPagamentoIncompleta;

            for (let i = 0; i < arr.length; i++) {
              if (
                arr[i].cdFormapgto == 4 ||
                arr[i].cdFormapgto == 9 ||
                arr[i].cdFormapgto == 2 ||
                arr[i].cdFormapgto == 8 ||
                arr[i].cdFormapgto == 917
              ) {
                this.frmPgmtIncompleta = true;
              } else {
                this.frmPgmtIncompleta = false;
              }
            }
          });

          bloqueioLiberado.forEach((item) => {
            let arr = item.Bloqueios;

            for (let i = 0; i < arr.length; i++) {
              if (arr[i].DT_LIBERACAO != null) {
                this.bloqueioLiberado.push(arr[i].DT_LIBERACAO);
              } else {
                this.bloqueioLiberado = null;
              }
            }
          });

          line.forEach((item) => {
            let arr = item.emails;

            for (let i = 0; i < arr.length; i++) {
              this.timeline.push(arr[i]);
            }
          });

          this.orderPrint = order;

          this.dadosSolar = response.data[0].orderConfigs;

          this.statusPedido = response.data[0].StatusPedido;

          this.vendaZEFU = response.data[0].TPVenda === "ZEFU" ? true : false;

          if (this.statusPedido != "CANCELADO") {
            let formasPgmt = response.data[0].frmPagamento;
            // Verifica se é PIX
            let pix = formasPgmt.filter((pgto) => pgto.dsformapgto == "PIX");
            if (pix.length > 0) {
              let tid = pix[0].TID;
              axios
                .get(
                  `https://www.leverosintegra.com.br/MAP/api/SpinPay?token=${this.token}&referenceId=${tid}`
                )
                .then((res) => {
                  let data = res.data;
                  this.imagePix = data.urlImage;
                  this.codPix = data.code;
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }

          itens.forEach(function(e) {
            if (e.cjPedido.length != -1) {
              itens = e.cjPedido;
            }
          });
          this.itensPedido = itens;

          log.forEach(function(x) {
            if (x.logstatus.length != -1) {
              log = x.logstatus;
            }
          });

          this.logStatus = log;

          bloqueio.forEach(function(b) {
            if (b.Bloqueios.length != -1) {
              bloqueio = b.Bloqueios;
            }
          });

          this.bloqueios = bloqueio;

          // Calcula valor total de RT
          if (this.infos[0].orderConfigs) {
            this.infos[0].orderConfigs.forEach((el) => {
              this.valorTotalRTSolar += el.ZRTS;
            });
          }
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },

    clickPix() {
      var range_ = document.createRange(); // create new Range object
      range_.selectNode(document.getElementById("to-copy")); // set our Range to contain the Node we want to copy from
      window.getSelection().removeAllRanges(); // remove any previous selections
      window.getSelection().addRange(range_); // select
      document.execCommand("copy"); // copy to clipboard
      window.getSelection().removeAllRanges(); // remove selection
    },

    cancelOrder() {
      // if (!this.userPassword) {
      //   alert("É necessário digitar a senha para prosseguir!");
      //   return;
      // }
      let dados = JSON.parse(localStorage.getItem("login"));

      // Cancela o pedido pelo token do usuário logado
      axios({
        method: "post",
        data: {},
        url: `https://www.leverosintegra.com.br/MAP/api/pedido/${this.nrPedido}=cancel-token${dados.token}`,
        //url: `http://qa.leverosintegra.com.br/map/api/pedido/${this.nrPedido}=cancel-token${dados.token}`,
      })
        .then((res) => {
          if (res.data.retorno == "Cancelado com sucesso") {
            alert("Pedido " + res.data.orderId + " cancelado com sucesso!");
            document.location.reload();
          } else {
            alert("Erro: " + res.data.retorno);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 409) {
            alert(
              err.response.data.retorno +
                ". Verifique a senha e tente novamente!"
            );
          }
        });
    },

    printOrder() {
      window.open(
        `/panel/orders/OrderPrint?Pedido=${window.btoa(this.orderPrint)}`,
        "_blank"
      );
    },
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.loja {
  position: fixed;
  bottom: 10px;
  right: 20px;
  background: var(--standardGreen);
  padding: 8px;
  border-radius: 5px;
  z-index: 99999;

  a {
    color: var(--customWhite);
    text-decoration: none;
    font-size: 1rem;
  }
}

.detailsOrder {
  width: 95%;
  margin: 0 auto;
  padding-top: 40px;

  @media (min-width: 441px) {
    width: 98%;
  }
}

.blocked {
  background: rgb(250, 89, 89);
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  width: 100%;

  @media (min-width: 769px) {
    width: 50%;
  }

  p {
    color: #fff;

    a {
      color: #fff;
    }
  }
}
.orderheader {
  background: var(--customGray-50);
  border-radius: 5px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid var(--customGray-100);
  flex-direction: column;

  p {
    padding: 0 5px;
    color: #1a99d8;
    font: 0.8rem "Soleto", sans-serif;

    &:nth-child(2) {
      font-weight: bold;
      color: var(--customGray-500);
    }

    a {
      color: #1a99d8;
      text-decoration: none;
      font: 700 1.6rem "Soleto", sans-serif;
    }
  }
}

.header {
  justify-content: space-between;

  @media (min-width: 441px) {
    display: flex;
    flex-direction: row;
  }

  &__order {
    display: flex;
    align-items: center;

    p {
      padding: 0 5px;

      &:nth-child(2) {
        font-weight: bold;
        color: var(--customGray-500);
      }

      a {
        color: #1a99d8;
        text-decoration: none;
        font: 700 1.6rem "Soleto", sans-serif;
      }
    }

    h1 {
      color: var(--customGray-500);
      font-size: 1.375rem;
    }
  }

  &__buttons {
    @media (max-width: 440px) {
      display: flex;
      flex-direction: column;
      padding-top: 20px;
    }

    &--log {
      color: var(--customGray-500);
      margin: 10px 10px 10px 0;
      outline: none;
      font-size: 0.95rem;
    }

    &--print {
      border: 1px solid #069c06;
      border-radius: 10px;
      color: #069c06;
      padding: 7px;
      margin: 10px 10px 10px 0;
      outline: none;
      font-size: 0.95rem;

      &:hover {
        background: #069c06;
        color: var(--customWhite);
      }
    }

    &--cancel {
      border: 1px solid #c70707;
      border-radius: 10px;
      color: #c70707;
      padding: 7px;
      margin: 10px 10px 10px 0;
      outline: none;
      font-size: 0.95rem;

      &:hover {
        background: #c70707;
        color: var(--customWhite);
      }
    }
  }

  &__logModal {
    position: absolute;
    height: 300px;
    background: var(--customGray-70);
    border-radius: 5px;
    overflow-y: auto;
    padding: 10px;
    border: 1px solid var(--customGray-100);
    left: 35px;
    width: 290px;
    margin-top: 40px;

    @media (min-width: 441px) {
      left: initial;
      width: 280px;
      margin-top: 0;
    }

    h3 {
      color: var(--customGray-500);
      font-size: 0.95rem;
      padding-bottom: 15px;
    }
  }

  &__modalMessages {
    p {
      padding-bottom: 15px;
      font: 500 0.95rem/1.4 "Soleto", sans-serif;

      span {
        font: 700 0.95rem "Soleto", sans-serif;
      }
    }
  }

  &__modalCancelOrder {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: var(--customWhite);
    box-shadow: 0 4px 10px #2c2c2c;
  }

  &__modalTitle {
    background: var(--customGray-500);
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      padding: 20px;
      color: var(--customGray-500);
    }

    i {
      padding: 20px;
      cursor: pointer;
    }
  }

  &__modalBody {
    padding: 20px;

    input {
      border: 1px solid var(--customGray-200);
      border-radius: 5px;
      padding: 3px;
      margin-left: 10px;
    }
  }

  &__modalFooter {
    padding: 20px;
    display: flex;
    justify-content: center;

    &--cancel {
      background: crimson;
      border-radius: 5px;
      padding: 5px;
      color: var(--customWhite);
    }
  }
}

.cards {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  flex-direction: column;

  @media (min-width: 441px) and (max-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  @media (min-width: 769px) {
    flex-direction: row;
  }

  &__item {
    background: var(--customGray-50);
    border-radius: 5px;
    padding: 20px;
    margin: 0 10px 0 0;
    border: 1px solid var(--customGray-100);

    h3 {
      color: var(--customGray-500);
      font-size: 0.95rem;
      padding-bottom: 15px;
    }

    h4 {
      color: #1a99d8;
      font-size: 1.1rem;
      padding-bottom: 15px;
    }

    p {
      color: var(--customGray-500);
      font: 400 0.95rem/1.4 "Soleto", sans-serif;

      a {
        text-decoration: none;
        color: #2c7ec2;
      }

      i {
        padding-right: 5px;
      }

      span {
        font-weight: bold;
      }
    }

    &--client,
    &--address,
    &--partner {
      width: 100%;
      margin-bottom: 15px;

      @media (min-width: 441px) and (max-width: 768px) {
        width: 47%;
        margin: 10px;
      }

      @media (min-width: 769px) {
        width: 48%;
        margin-bottom: 0;
      }
    }

    &--client {
      .icon-change {
        display: flex;
        justify-content: flex-end;
        position: relative;
        top: 15px;
        color: var(--customGray-500);
        cursor: pointer;
      }
    }

    &--address {
      p:last-child {
        padding-top: 25px;

        span {
          font-weight: bold;
        }
      }
    }

    &--medium {
      width: 100%;
      margin-bottom: 15px;

      @media (min-width: 441px) and (max-width: 768px) {
        width: 47%;
        margin: 10px;
      }

      @media (min-width: 769px) {
        width: 28%;
        margin-bottom: 0;
      }
    }
  }

  &__infoStatus {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (min-width: 441px) {
      margin-top: 30px;
    }

    &--pendente {
      color: orange !important;
    }

    &--entregue {
      color: #4b6ee2 !important;
    }

    &--aprovado {
      color: #13c513 !important;
    }

    &--cancelado {
      color: #e21e1e !important;
    }

    &--aguardandoPagamento {
      color: #e29d1e !important;
    }

    &--analiseRisco {
      color: #c22a1f !important;
    }

    &--expirado {
      color: #9b9b9b !important;
    }
    &--faturado {
      color: #1d8b0f !important;
    }

    &--parcialmenteFaturado {
      color: #167c08 !important;
    }

    &--pay {
      background: #1d8b0f;
      color: #fff;
      padding: 7px;
      border-radius: 5px;
      font: 500 1rem "Soleto", sans-serif;
      text-decoration: none;
      margin-top: 20px;
    }
  }
}

.itemsPayment {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 30px 0 80px 0;
  flex-direction: column;

  @media (min-width: 441px) {
    flex-direction: row;
  }

  &__items {
    background: var(--customGray-50);
    border-radius: 5px;
    padding: 20px;
    border: 1px solid var(--customGray-100);
    width: 100%;
    margin-bottom: 30px;

    @media (min-width: 441px) {
      width: 70%;
      margin-bottom: 0;
    }

    h3 {
      color: var(--customGray-500);
      font-size: 0.95rem;
      padding-bottom: 15px;
    }
  }

  &__image {
    width: initial;

    @media (min-width: 441px) {
      width: 20%;
    }
  }

  &__details {
    padding: 25px 0;
    width: initial;

    @media (min-width: 441px) {
      width: 60%;
      padding: 0;
    }

    p {
      color: var(--customGray-500);
      font: 500 0.95rem/1.4 "Soleto", sans-serif;

      &:nth-child(1) {
        font-weight: bold;
        color: #1a99d8;
        padding-bottom: 10px;
      }

      span {
        font: 700 0.95rem "Soleto", sans-serif;
      }
    }

    h4 {
      padding: 10px 0;
      color: var(--customGray-500);
      font-size: 0.95rem;
    }

    ul {
      padding-left: 25px;

      li {
        list-style: none;
        font-size: 0.85rem;
        color: var(--customGray-500);
        line-height: 1.5;
      }
    }
  }

  &__valueQuantity {
    width: initial;

    @media (min-width: 441px) {
      width: 20%;
    }

    p {
      color: #1a99d8;
      font: 500 0.95rem/1.6 "Soleto", sans-serif;

      &:nth-child(2) {
        font-weight: bold;
      }
    }
  }

  &__product {
    background: var(--customWhite);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    margin: 20px 0;
    flex-direction: column;

    @media (min-width: 769px) {
      flex-direction: row;
    }
  }

  &__block {
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (min-width: 441px) {
      width: 28%;
    }
  }

  &__blockade {
    margin-top: 30px;
  }

  &__card {
    background: var(--customGray-50);
    border-radius: 5px;
    border: 1px solid var(--customGray-100);
    padding-bottom: 20px;

    h3 {
      color: var(--customGray-500);
      font-size: 0.95rem;
      padding: 20px;
    }

    &--title {
      color: var(--customGray-500);
      font-size: 0.95rem;
      padding: 20px 0 0 20px;
    }

    p {
      color: var(--customGray-500);
      font: 500 0.95rem/1.5 "Soleto", sans-serif;

      span {
        color: var(--customGray-500);
        font: 700 0.95rem "Soleto", sans-serif;
      }
    }
  }

  &__itemCard {
    padding: 10px 20px 10px 20px;
    background: var(--customGray-50);
    border-radius: 5px;

    h4 {
      color: #1a99d8;
      font-size: 1.5rem;
      padding-bottom: 15px;
    }

    p {
      color: var(--customGray-500);
      font: 500 0.95rem/1.7 "Soleto", sans-serif;

      span {
        font: 700 0.95rem "Soleto", sans-serif;
      }
    }

    a {
      color: var(--customWhite);
      background: #127985;
      border-radius: 5px;
      padding: 7px;
      text-decoration: none;
      font-size: 0.95rem;

      &:hover {
        background: var(--standardGreen);
      }
    }

    &--boleto {
      margin-bottom: 20px;
    }
  }

  &__actions {
    padding: 15px;
    margin-top: 30px;
    background: var(--customGray-50);
    border-radius: 5px;
    border: 1px solid var(--customGray-100);

    h3 {
      color: var(--customGray-500);
      font-size: 0.95rem;
      padding-bottom: 15px;
    }

    button {
      border: 1px solid var(--standardGreen);
      border-radius: 5px;
      padding: 5px;
      margin-top: 15px;
      width: 100%;
      color: var(--standardGreen);
      outline: none;
      font-size: 0.95rem;
    }
  }

  &__addMessage {
    border-bottom: 1px solid var(--customGray-500);
    padding-bottom: 20px;

    textarea {
      border: 1px solid var(--customGray-500);
      border-radius: 5px;
      margin-top: 10px;
      padding: 10px;
      color: var(--customGray-500);
    }

    button {
      background: var(--standardGreen);
      color: var(--customWhite);
    }
  }

  &__linkGroup {
    padding-top: 20px;
    select {
      margin-left: 3px;
      border: 1px solid var(--customGray-500);
      border-radius: 5px;
      padding: 5px;
    }

    input[type="text"] {
      margin-left: 3px;
      border: 1px solid var(--customGray-500);
      border-radius: 5px;
      padding: 5px;
      width: 179px;
    }

    button {
      background: var(--standardGreen);
      color: var(--customWhite);
    }
  }
}

.timeline {
  .item {
    &__title {
      font: 700 1.2rem "Soleto", sans-serif;
      padding-bottom: 10px;
    }

    &__subtitle {
      font: 700 1.2rem "Soleto", sans-serif;
      color: #005a64;
      padding-bottom: 10px;
    }

    &__billed {
      padding: 10px 0 30px 0;
    }

    &__infos {
      border-radius: 10px;
      border: 1px solid #d1d1d1;
      padding: 10px;
    }
  }
}

::v-deep .v-application--wrap {
  min-height: fit-content;
}

.v-tooltip__content {
  opacity: 1 !important;
  white-space: nowrap;
}
</style>
